import { useState, useEffect, useCallback } from 'react';

import { Input, Row, Col, Button, Label, FormGroup, SheetFooter, SheetBody, FormFeedback } from 'twyne-new.ui'

import { useMetaFieldStore } from '../store';

export default function MetaFieldForm({ data, onSubmit, onCancel }) {
  const { lists: { 'meta-fields': { useLoad, items } } } = useMetaFieldStore()

  const [keys, setKeys] = useState([])
  const [key, setKey] = useState('')
  const [keyError, setKeyError] = useState('')

  const handleKey = useCallback(event => {
    const value = event.target.value
      .replace(/ /g, '_')
      .replace(/[^a-zA-Z0-9_]/g, '')
      .replace(/^([0-9])/, '')
      .toLowerCase()
      setKey(value)
    setKeyError('')
  }, [])

  const handleSubmit = useCallback(async () => {
    if (!key) {
      return setKeyError('Required')
    }

    if (keys.includes(key)) {
      return setKeyError('Key already exists')
    }

    await onSubmit({ key })
  }, [onSubmit, keys, key])

  useLoad()

  useEffect(() => {
    if (!key && data?.key) {
      setKey(data.key)
    }
  }, [key, data])

  useEffect(() => {
    if (!keys.length) {
      setKeys(items.map(({ key }) => key))
    }
  }, [keys, items])

  return <>
    <SheetBody>
      <Row>
        <Col>
          <FormGroup>
            <Label>Key</Label>
            <Input name='key' value={key} onChange={handleKey} required error={!!keyError} />
            {keyError && <FormFeedback>{keyError}</FormFeedback>}
          </FormGroup>
        </Col>
      </Row>
    </SheetBody>
    <SheetFooter>
      <Button onClick={onCancel} variant='ghost'>Cancel</Button>
      <Button onClick={handleSubmit} color='accent'>Save</Button>
    </SheetFooter>
  </>
}
